import { reverse } from "@reactivated";

import { loadCSRFToken } from "@thelabnyc/thelabui/src/utils/api";

export const recaptchaProtectedApi = (key: string) => {
    const registerForNewsletter = async (form: HTMLFormElement) => {
        if (!window.grecaptcha) throw new Error("Couldn't access recaptcha");
        const csrf = loadCSRFToken();
        const token = await window.grecaptcha.execute(key, {
            action: "submit",
        });
        if (token) {
            const data = new FormData(form);
            data.set("csrfmiddlewaretoken", await csrf);
            data.set("recaptcha", token);

            const response = await fetch(reverse("newsletter-subscribe"), {
                method: "POST",
                body: data,
                headers: [["Accept", "application/json"]],
            });
            if (response.ok) {
                return;
            } else {
                throw await response.json();
            }
        }
    };
    return { registerForNewsletter };
};
